module.exports = __webpack_public_path__ + "img/login-bg1.f18c1918.png";